import type { AppMessages } from '../types';

const messages: AppMessages = {
  'app.default.title': '{appName} - 接口文档分享',
  'app.default.keywords':
    '{appNamePrefix}API 协作工具,接口文档,API 调试,API Mock,API 自动化测试,API 文档管理,接口文档自动生成工具,接口调试',
  'app.default.description':
    '{appNamePrefix}API 一体化协作平台，提供 API 文档管理工具、接口 Mock 工具、接口自动化测试工具、接口调试工具于一体，提升 10 倍研发效率。 {appName} = Postman + Swagger + Mock + JMeter。',
} as const;

export default messages;
